import type {ParameterSource} from "../parameter-resolution";

/**
 * Anzeigename des Objekt-Tabs je Änderungs-Schicht (`layer` im Änderungsprotokoll), für die Spalte
 * „Tab“ in Änderungen/Kommentare (client) und in der Kommentar-Anlage des PDFs (reva-pdf).
 *
 * Als `Record<ParameterSource, …>` getippt, damit eine neue Schicht hier nicht vergessen wird.
 */
export const LAYER_TO_OBJECT_TABS: Record<ParameterSource, string> = {
    avm: "Überblick",
    firstFinalize: "Abschluss",
    register: "Grundbuch",
    energy: "Energieausweis",
    idpEnergyCertificate: "Energieausweis",
    plot: "Grundstück",
    inspectionDerived: "Besichtigung",
    inspection: "Besichtigung",
    initialValuation: "Erstbewertung",
    immodrop: "Exposé",
};

/** Tab-Name zur Schicht; unbekannte Schichten fallen auf den Schlüssel selbst zurück. */
export function layerToObjectTab(layer: string | null | undefined): string {
    if (!layer) return "";
    return LAYER_TO_OBJECT_TABS[layer as ParameterSource] ?? layer;
}
